export default {
  setServiceList ({ commit }, payload) {
    commit('setServiceList', payload)
  },
  setSearch ({ commit }, payload) {
    commit('setSearch', payload)
  }
}
